function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "icons8-lock2");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Desktop-HD",
  transform: "translate(-566.000000, -513.000000)"
}, React.createElement("g", {
  id: "Group-3",
  transform: "translate(547.000000, 502.000000)"
}, React.createElement("image", {
  id: "icons8-lock2",
  x: 13,
  y: 8,
  width: 37,
  height: 37,
  xlinkHref: "data:image/png;base64,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"
}))));

var SvgPassword = function SvgPassword(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "25px",
    height: "31px",
    viewBox: "0 0 25 31",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPassword, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/password.664a0fa8.svg";
export { ForwardRef as ReactComponent };